export const LINELIST_PERMISSION = 'linelist:view';

export function canViewLinelist(user?: { role?: string; permissions?: string[] } | null): boolean {
  if ((user?.role || '').toUpperCase() === 'SUPER_ADMIN') {
    return true;
  }
  return Boolean(user?.permissions?.includes(LINELIST_PERMISSION));
}
